(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  ko.utils.stringStartsWith = function(string, startsWith) {
    string = string || '';
    if (startsWith.length > string.length) {
      return false;
    }
    return string.substring(0, startsWith.length) === startsWith;
  };

  ko.utils.tagNameLower = function(element) {
    return element && element.tagName && element.tagName.toLowerCase();
  };

  ko.expressionRewriting.writeValueToProperty = function(property, allBindingsAccessor, key, value, checkIfDifferent) {
    var propWriters;
    if (!property || !ko.isObservable(property)) {
      propWriters = allBindingsAccessor()['_ko_property_writers'];
      if (propWriters && propWriters[key]) {
        return propWriters[key](value);
      }
    } else if (ko.isWriteableObservable(property) && !checkIfDifferent || property.peek() !== value) {
      return property(value);
    }
  };

  ko.selectExtensions.writeValueAndTriggerChange = function(element, value) {
    var i, j, ref, ref1;
    switch (ko.utils.tagNameLower(element)) {
      case 'option':
        switch (typeof value) {
          case 'string':
            ko.utils.domData.set(element, ko.bindingHandlers.options.optionValueDomDataKey, void 0);
            if (indexOf.call(element, hasDomDataExpandoProperty) >= 0) {
              delete element[hasDomDataExpandoProperty];
            }
            element.value = value;
            break;
          default:
            ko.utils.domData.set(element, ko.bindingHandlers.options.optionValueDomDataKey, value);
            element[hasDomDataExpandoProperty] = true;
            element.value = (ref = typeof value === 'number') != null ? ref : {
              value: ''
            };
        }
        break;
      case 'select':
        if (value === '') {
          value = void 0;
        }
        if (value === null || value === void 0) {
          element.selectedIndex = -1;
        }
        for (i = j = ref1 = element.options.length - 1; ref1 <= 0 ? j <= 0 : j >= 0; i = ref1 <= 0 ? ++j : --j) {
          if (ko.selectExtensions.readValue(element.options[i]) === value) {
            element.selectedIndex = i;
            break;
          }
        }
        if (!(element.size > 1) && element.selectedIndex === -1) {
          element.selectedIndex = 0;
        }
        break;
      default:
        if (value === null || value === void 0) {
          value = '';
        }
        element.value = value;
    }
    return $(element).trigger('change');
  };

  ko.bindingHandlers['valueTriggerChange'] = {
    init: function(element, valueAccessor, allBindingsAccessor) {
      var eventsToCatch, propertyChangedFired, requestedEventsToCatch, valueUpdateHandler;
      eventsToCatch = ['change'];
      requestedEventsToCatch = allBindingsAccessor()['valueUpdate'];
      propertyChangedFired = false;
      if (requestedEventsToCatch) {
        if (typeof requestedEventsToCatch === 'string') {
          requestedEventsToCatch = [requestedEventsToCatch];
        }
        ko.utils.arrayPushAll(eventsToCatch, requestedEventsToCatch);
        eventsToCatch = ko.utils.arrayGetDistinctValues(eventsToCatch);
      }
      valueUpdateHandler = function() {
        var elementValue, modelValue;
        propertyChangedFired = false;
        modelValue = valueAccessor();
        elementValue = ko.selectExtensions.readValue(element);
        return ko.expressionRewriting.writeValueToProperty(modelValue, allBindingsAccessor, 'value', elementValue);
      };
      return ko.utils.arrayForEach(eventsToCatch, function(eventName) {
        var handler;
        handler = valueUpdateHandler;
        if (ko.utils.stringStartsWith(eventName, 'after')) {
          handler = function() {
            return setTimeout(valueUpdateHandler, 0);
          };
          eventName = eventName.substring('after'.length);
        }
        return ko.utils.registerEventHandler(element, eventName, handler);
      });
    },
    update: function(element, valueAccessor) {
      var applyValueAction, elementValue, newValue, valueHasChanged, valueIsSelectOption;
      valueIsSelectOption = ko.utils.tagNameLower(element) === 'select';
      newValue = ko.utils.unwrapObservable(valueAccessor());
      elementValue = ko.selectExtensions.readValue(element);
      valueHasChanged = newValue !== elementValue;
      if (valueHasChanged) {
        applyValueAction = function() {
          return ko.selectExtensions.writeValueAndTriggerChange(element, newValue);
        };
        applyValueAction();
      }
      if (valueIsSelectOption && element.length > 0) {
        return ensureDropdownSelectionIsConsistentWithModelValue(element, newValue, false);
      }
    }
  };

}).call(this);
